import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { App as CapacitorApp } from '@capacitor/app';

export default function BackButtonHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    let handle;

    (async () => {
      handle = await CapacitorApp.addListener('backButton', () => {
        if (window.history.length > 1) {
          navigate(-1);
        } else {
          CapacitorApp.exitApp();
        }
      });
    })();

    return () => {
      handle?.remove();
    };
  }, [navigate]);

  return null;
}
